import { Box, Button, Heading, Stack, Text } from 'components/ui';
import Link from 'next/link';
import { FC } from 'react';
import styled from 'styled-components';
import { breakpoints, generateCustomPropertyKey, Theme } from 'styles/theme';

type CTABlockContent = {
  title: string;
  description?: string;
  linkCTA: string;
  link: string;
  color?: keyof Theme['colors'];
};

export interface CTABlockProps {
  content: CTABlockContent[];
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: var(--space-3);
`;

const BlockWrapper = styled(Box)`
  --padding: var(--space-4);
  --background-color: var(--color-green);

  display: flex;
  flex-direction: column;

  &:last-child {
    --background-color: var(--color-pink);
  }

  @media screen and (min-width: ${breakpoints.small}) {
    --padding: var(--space-6);
  }

  @media screen and (min-width: ${breakpoints.medium}) {
    --padding: var(--space-8);
  }

  @media screen and (min-width: ${breakpoints.large}) {
    --padding: var(--space-10);
  }
`;

const CTABlock: FC<CTABlockProps> = ({ content }) => {
  return (
    <Wrapper>
      {content.map((item, i) => {
        // Grab the relevant custom property names for prop overrides
        const colorVal =
          item.color &&
          `var(${generateCustomPropertyKey('colors', item.color)})`;

        return (
          <BlockWrapper key={i} style={{ '--background-color': colorVal }}>
            <Stack space={3}>
              {item.title && (
                <Heading level='h4' color='white'>
                  {item.title}
                </Heading>
              )}
              {item.description && <Text>{item.description}</Text>}
              {item.link && (
                <Link href={item.link} passHref>
                  <Button as='a'>{item.linkCTA}</Button>
                </Link>
              )}
            </Stack>
          </BlockWrapper>
        );
      })}
    </Wrapper>
  );
};

export default CTABlock;
